import React from 'react';
import { SyncLoader } from 'react-spinners';

import LoadingContainer from './styles';

const Loading = ({ size, margin }) => (
  <LoadingContainer>
    <SyncLoader
      sizeUnit="px"
      size={size || 10}
      margin={margin || '2px'}
      color="#2FAA33"
      loading
    />
  </LoadingContainer>
);

export default Loading;
